import React from "react";

import { AskCareerScoutStarters, type AskCareerScoutStartersProps } from "./AskCareerScoutStarters";
import { DynamicConvoStarters } from "./DynamicConvoStarters";
import { useCareerScoutDynamicConvoStartersEnabled } from "./proctor";

export type CareerScoutStartersProps = Pick<AskCareerScoutStartersProps, "horizontalBleedInset">;

/**
 * "Ask Career Scout" starter chips. `career_scout_always_aware` decides where
 * these render; `career_scout_dynamic_convo_starters_vj_tst` decides whether
 * the job-aware dynamic pool replaces the three static starters (RN-7499).
 */
export const CareerScoutStarters: React.FC<CareerScoutStartersProps> = (props) =>
  useCareerScoutDynamicConvoStartersEnabled() ? (
    <DynamicConvoStarters {...props} />
  ) : (
    <AskCareerScoutStarters {...props} />
  );
